import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  /* Fecha y horas en una fila que se parte en dos si no cabe: nunca desborda el modal */
  .citation-datetime {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
  }

  .citation-date {
    flex: 1 1 180px;
    min-width: 0;
  }

  .time-range {
    flex: 1 1 280px;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;

    > div {
      flex: 1;
      min-width: 0;
    }

    .MuiInputBase-root {
      min-width: 0;
    }

    span {
      font-size: 14px;
      color: ${tokens.color.text.secondary};
    }
  }

  .online-meeting {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .MuiSwitch-thumb {
    border: ${props => `solid 1px ${props.theme.primary}`};
  }
`

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};
`

export const Link = styled.button`
  display: block;
  margin: 8px 0 0 auto;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.primary};
`
